<h5>{{ 'MODAL_CONTENTS.UBO_HELP.INFO' | translate }}</h5>
<ol>
  <li>{{ 'MODAL_CONTENTS.UBO_HELP.INFO_LIST_1' | translate }}</li>
  <li>{{ 'MODAL_CONTENTS.UBO_HELP.INFO_LIST_2' | translate }}</li>
  <li>{{ 'MODAL_CONTENTS.UBO_HELP.INFO_LIST_3' | translate }}</li>
  <li>{{ 'MODAL_CONTENTS.UBO_HELP.INFO_LIST_4' | translate }}</li>
</ol>
